import { IQuoteSummary } from "../interfaces/IQuoteSummery";
import { thanos26GetJson, thanos26PostJson } from "./thanos26Client";

const URL_OFFER = "manager/Offer";

async function GetVersions(id: number): Promise<any> {
    return thanos26GetJson(URL_OFFER, { id: id.toString() });
}

async function GetQuote(id: number, version: string): Promise<IQuoteSummary> {
    return thanos26GetJson(URL_OFFER, { id: id.toString(), version: version });
}

export async function SaveQuote(offer: IQuoteSummary): Promise<any> {
    return thanos26PostJson(URL_OFFER, { id: String(offer.id), version: String(offer.version) }, offer);
}

export default { GetVersions, GetQuote, SaveQuote };
